export default "__VITE_PUBLIC_ASSET__270c3619__"